import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Verifiied from "../../assets/lottie/Verified.jsx";
import TitleWithSeemore from "../../components/TitleWithSeemore";
import Loader from "../../assets/lottie/Loader.jsx";

const VerifiedKyc = () => {
  const navigate = useNavigate();
  const [loading, setloading] = useState();
  return (
    <div className="bg-white mrlb-5per mt-6">
      <TitleWithSeemore title="Verify Identity" viewall={false} onBack={true} />
      <div
        style={{
          padding: "5%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          flexWrap: "wrap",
        }}
      >
        <div>
          <Verifiied size={window.innerWidth > 800 ? 500 : 300} />
        </div>
        <div
          style={{
            width: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: 20,
          }}
        >
          <div className="profile-text mb-6" style={{ textAlign: "center" }}>
            Verification completed Successfully !
          </div>
          <div
            className="profile-sub-text mb-10"
            style={{ textAlign: "center" }}
          >
            Now you are eligible to buy and sell Jewellery on our Platform
            <div>Thank You!</div>
          </div>
          {loading ? (
            <Loader size={200} />
          ) : (
            <button
              onClick={() => {
                navigate("/");
              }}
              className="next-auth-button"
            >
              Go to Home
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifiedKyc;
